import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function KRFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-dhqt6da91" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-qnm8avlmf" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-hv3hpbx79" />
          </mask>
          <mask id="mantine-zz4tyh461" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-vmv37q5kd" />
          </mask>
          <ellipse id="mantine-vmv37q5kd" cx="5.799" cy="6.159" rx="5.799" ry="6.159" />
          <path id="mantine-hv3hpbx79" d="M0 0h32v24H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-dhqt6da91)">
          <use fill="#f7fcff" xlinkHref="#mantine-hv3hpbx79" />
          <g mask="url(#mantine-qnm8avlmf)">
            <g transform="translate(10.201 5.902)">
              <use fill="#3d58db" xlinkHref="#mantine-vmv37q5kd" />
              <path
                fill="#e31d1c"
                d="M11.801 6.63c-.217-1.936-1.13-2.956-2.736-3.061-2.41-.158-3.06 2.13-3.2 2.735s-.491 2.223-3.03 2.223c-1.691 0-2.614-1.37-2.766-4.11V-.432H11.8z"
                mask="url(#mantine-zz4tyh461)"
              />
            </g>
            <path
              fill="#272727"
              fillRule="nonzero"
              d="M10.31 4.747l.915.828-4.1 4.917-.914-.828zM8.808 3.391l.915.828-4.088 4.88-.915-.828zM7.3 2.052l.915.828-4.24 4.952-.915-.828zm17.865 5.763l-.915.824 1.587 1.863.915-.824zM23.91 3.007l-.915.824 4.418 5.381.915-.824zm4.274 2.125l-.915.824 1.588 1.863.915-.824zm-5.842-.744l-.915.825 1.587 1.863.916-.825zm3.02-2.683l-.914.825 1.587 1.862.915-.824zm.125 17.695l.923.828-1.601 1.87-.923-.828zm-1.52-1.422l.922.828-1.67 1.997-.923-.828zm-1.526-1.272l.923.828-1.601 1.87-.923-.827zm5.605-.673l.923.827-1.6 1.87-.923-.827zm-1.338-1.382l.923.827-1.671 1.997-.923-.827zm-1.576-1.236l.923.828-1.6 1.87-.924-.827zM4.31 16.69l-.916.826L7.5 22.26l.915-.826zm3.965 1.468l-.916.826 1.726 1.895.915-.825zm-.953-4.093l-.915.825 4.084 4.68.915-.825zm-1.446 1.262l-.915.825 1.495 1.754.915-.825z"
            />
          </g>
        </g>
      </svg>
    </Box>
  );
}
